import React from "react";
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useSearchParams } from "react-router-dom";
import AdminPageHeader from "../Shared/AdminPageHeader";
import NewsletterEditor from "./newsletter-editor/NewsletterEditor";
import NewsletterPubblicaTab from "./newsletter/NewsletterPubblicaTab";
import NewsletterIscrittiTab from "./newsletter/NewsletterIscrittiTab";
import { enableNewsletterEditor } from "../../config/newsletterEditorConfig";
import {
  contentPageShellSx,
  contentTabsSx,
} from "./content/contentEditorStyles";

const TAB_ISCRITTI = "iscritti";
const TAB_EDITOR = "editor";
const TAB_PUBBLICA = "pubblica";

const tabIndexFromKey = (key) => {
  if (key === TAB_EDITOR) {
    return 1;
  }
  if (key === TAB_PUBBLICA) {
    return 2;
  }
  return 0;
};

const tabKeyFromIndex = (index) => {
  if (index === 1) {
    return TAB_EDITOR;
  }
  if (index === 2) {
    return TAB_PUBBLICA;
  }
  return TAB_ISCRITTI;
};

const GestioneNewsletter = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || TAB_ISCRITTI;
  const tabIndex = tabIndexFromKey(activeTab);
  const editorDocumentId = searchParams.get("documentId") || undefined;

  const handleTabChange = (_, newIndex) => {
    const next = new URLSearchParams(searchParams);
    next.set("tab", tabKeyFromIndex(newIndex));
    setSearchParams(next, { replace: true });
  };

  return (
    <Box sx={contentPageShellSx}>
      <AdminPageHeader
        title="Newsletter"
        subtitle="Gestisci iscritti, crea contenuti ed invia le tue newsletter."
      />

      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        variant={isMobile ? "fullWidth" : "standard"}
        centered={!isMobile}
        sx={contentTabsSx}
      >
        <Tab label="Iscritti" />
        <Tab label="Editor" disabled={!enableNewsletterEditor} />
        <Tab label="Pubblica" />
      </Tabs>

      {tabIndex === 0 ? <NewsletterIscrittiTab /> : null}

      {enableNewsletterEditor ? (
        <Box sx={{ display: tabIndex === 1 ? "block" : "none" }}>
          <NewsletterEditor documentId={editorDocumentId} />
        </Box>
      ) : null}

      {tabIndex === 1 && !enableNewsletterEditor ? (
        <Typography sx={{ py: 4, textAlign: "center" }} color="text.secondary">
          Editor newsletter non abilitato.
        </Typography>
      ) : null}

      {tabIndex === 2 ? <NewsletterPubblicaTab /> : null}
    </Box>
  );
};

export default GestioneNewsletter;
